/**
 * What a camera's context menus add, in the Outliner and the viewport: Align
 * View to Camera (Unity's Align View to Selected: take its view, the viewport
 * staying free) and Pilot (Unreal's: look through it and move it). F keeps
 * framing a camera like any other entity.
 */
import type { CommandRequest } from "../../commands/types";
import type { EntityRecord } from "../../world/entity";
import type { MenuItem } from "../ui/Menu";

export function cameraMenuItems(
  entity: EntityRecord | undefined,
  run: (request: Omit<CommandRequest, "origin">) => void,
): MenuItem[] {
  if (!entity?.components.has("Camera")) return [];
  const payload = { entity: entity.id };
  return [
    {
      label: "Align View to Camera",
      run: () => {
        run({ type: "camera.alignTo", payload });
      },
    },
    {
      label: "Pilot",
      run: () => {
        run({ type: "camera.pilot", payload });
      },
    },
  ];
}
